import {
    Button,
    FlexRow,
    GridColumn,
    iconSizeSm,
    IGuiBinder,
    Index,
    LabeledDiv,
    TextInput,
    useProp,
    useTranslate,
} from '@synqo/frontend-component-library';
import { IconTrash } from '@tabler/icons-react';
import { useCallback } from 'react';

interface RemarkInputProps<T> {
    binder: IGuiBinder<T>;
    propertyName: Index<T>;
    value: string;
    canEdit: boolean;
    setRemarksShown: (updater: (latest: [Index<T>, string][]) => [Index<T>, string][]) => void;
}

export function RemarkInput<T>({ binder, propertyName, value, canEdit, setRemarksShown }: RemarkInputProps<T>) {
    const i18n = useTranslate('');

    const emProps = useProp(binder, propertyName);
    const { name, onChange } = emProps;

    const onDelete = useCallback(() => {
        onChange('', true);
        setRemarksShown((latest) => latest.filter((r) => r[0] !== propertyName));
    }, [onChange, setRemarksShown, propertyName]);

    const deleteButton = (
        <Button
            label={i18n(`Bemerkung - ${value} entfernen`)}
            onClick={onDelete}
            appearance="outlined"
            type="square"
            size="xxs"
        >
            <IconTrash size={iconSizeSm} />
        </Button>
    );
    const label = (
        <FlexRow>
            <LabeledDiv htmlFor={name} label={i18n(`Bemerkung - ${value}`)} />
            {canEdit && deleteButton}
        </FlexRow>
    );
    return (
        <GridColumn key={`column_remark_${value}`} span={12}>
            <TextInput {...emProps} inputSize={3} label={label} />
        </GridColumn>
    );
}
